import styled from 'styled-components';

import { FormControl } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

export const FormStyled = styled.form`
  padding: 0px;
`;

export const DoneIconStyled = styled(DoneIcon)`
  color: green !important;
`;
export const FormControlRadioStyled = styled(FormControl)`
  margin-left: 40px !important;
`;
export const DivSubmitButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: '0px 0px 0px 10px';
  margin-top: -5px;
`
export const DivSpinner = styled.div`
display: flex;
justify-content: center;
margin-top: 20px;
`;

export const DivFormTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;

export const FormStatus = styled.div`
  border-left: 3px solid lightgreen;
  padding-top: 10px;
  padding-left: 10px;
`;

export const FormStatusLabel = styled.p`
  font-weight: 800;
  font-size: 1rem;
  margin: 0px;
`;

export const FormStatusValue = styled.p`
  font-weight: 500;
  font-size: 1.2rem;
  margin: 0px;
`;

export const ExpandPainelContainer = styled.div`
  padding: 0px;
  display: initial;
  .MuiButtonBase-root {
    cursor: default;
  }
  .MuiAccordionSummary-content {
    cursor: default;
    display: initial;
    margin: 0px 0px 60px 0px;
    padding: 0px 10px 0px 10px;
  }
  .MuiAccordion-root {
    background-color: #f5f5f5;
  }
  .MuiAccordionDetails-root {
    display: initial;
    margin-top: -20px;
  }
  .MuiAccordionSummary-root {
    margin-bottom: -40px;
  }
  .MuiCollapse-wrapper {
    margin-top: 0px;
    padding: 0px 25px 0px 25px;
  }
  .MuiAccordion-rounded {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    box-shadow: none;
  }
`;

export const ExpandPainelItemContainer = styled.div`
  margin-bottom: 10px;
`;

export const ExpandPainelItemLabel = styled.p`
  font-size: 0.8rem;
  color: #999;
  margin-bottom: 5px;
`;

export const ExpandPainelItem = styled.p`
  font-size: 1rem;
  color: black;
`;

export const ExpandPainelButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  .MuiSvgIcon-root {
    transform: ${props => props.active ? 'rotate(180deg)': 'rotate(0deg)'};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  transition: 2s;
`;

export const FormNewMaintenance = styled.div`
  position: relative;
  margin: 40px 0px 20px 0px;
  height: 150px;
  background-color: #e9e9e9;
  border-radius: 8px;
  padding: 20px 20px 0px 20px;
`;

export const InputView = styled.input`
  height: 70px;
  width: 100%;
  border: none;
  padding-left: 20px;
  font-size: 1.1rem;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
`;

export const InputIconGroup = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const InputIcon = styled.div`
  display: flex;
  margin: 20px 15px 0px 15px;
`;

export const InputIconLabel = styled.span`
  color: #999;
  margin-left: 10px;
  font-size: 1rem;
`;